import type { RootState } from '../index';

export const selectCurrentWorkspace = (state: RootState) => state.workspace.currentWorkspace;

export const selectWorkspaces = (state: RootState) => state.workspace.workspaces;

export const selectWorkspaceLoading = (state: RootState) => state.workspace.isLoading;

export const selectWorkspaceById = (workspaceId: string) => (state: RootState) =>
  state.workspace.workspaces.find((ws) => ws.id === workspaceId);

export function selectWorkspaceId(state: RootState): string {
  return state.workspace.currentWorkspace?.id || 'private';
}
